module.exports = __webpack_public_path__ + "img/logo.34c90d82.svg";